import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtoolbarcompoComponent } from './gtoolbarcompo/gtoolbarcompo.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
// import { ToastrModule } from 'ngx-toastr';



@NgModule({
  declarations: [GtoolbarcompoComponent
  ],
  exports: [GtoolbarcompoComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule
  ]
})
export class GtoolbarModule { }
